import React from 'react';
import { CreditCard, History, ArrowRight } from 'lucide-react';
import { MobileLayout } from '../components/MobileLayout';
export function CreditiPage() {
  const transactions = [{
    id: '1',
    date: '22 Gen',
    description: 'Richiesta #REQ-0156',
    amount: -15
  }, {
    id: '2',
    date: '20 Gen',
    description: 'Richiesta #REQ-0155',
    amount: -12
  }, {
    id: '3',
    date: '18 Gen',
    description: 'Richiesta #REQ-0154',
    amount: -8
  }, {
    id: '4',
    date: '15 Gen',
    description: 'Acquisto 50 crediti',
    amount: 50
  }, {
    id: '5',
    date: '12 Gen',
    description: 'Richiesta #REQ-0153',
    amount: -18
  }];
  return <MobileLayout data-id="element-404">
      {/* Page Header - Same style as Homepage */}
      <div className="mb-6 lg:mb-8" data-id="element-405">
        <h1 className="text-xl lg:text-2xl font-montserrat font-bold text-navy" data-id="element-406">
          Crediti
        </h1>
        <p className="text-xs lg:text-sm text-gray-500 mt-1" data-id="element-407">
          Gestisci i tuoi crediti per accettare richieste
        </p>
      </div>

      {/* Balance Card - Same style as Homepage widgets */}
      <div className="mb-6 bg-white border border-gray-200 rounded-xl p-4" data-id="element-408">
        <div className="flex items-center gap-2 mb-3" data-id="element-409">
          <CreditCard size={14} className="text-gray-400" data-id="element-410" />
          <span className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-411">
            Saldo disponibile
          </span>
        </div>
        <div className="flex items-baseline gap-2" data-id="element-412">
          <span className="text-3xl font-bold text-navy" data-id="element-413">42</span>
          <span className="text-sm text-gray-500" data-id="element-414">crediti</span>
        </div>
        <div className="text-xs text-gray-400 mt-2" data-id="element-415">
          Ultimo acquisto: 15 Gen 2024
        </div>
      </div>

      {/* Credit Packages Section */}
      <div className="mb-6" data-id="element-416">
        <div className="flex items-center gap-2 mb-3" data-id="element-417">
          <CreditCard size={14} className="text-gray-400" data-id="element-418" />
          <h2 className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-419">
            Acquista crediti
          </h2>
        </div>

        <div className="space-y-3" data-id="element-420">
          {/* Package 1 */}
          <div className="bg-white border border-gray-200 rounded-xl p-4 hover:border-gray-300 transition-colors" data-id="element-421">
            <div className="flex items-center justify-between" data-id="element-422">
              <div data-id="element-423">
                <p className="text-sm font-semibold text-navy" data-id="element-424">50 crediti</p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-425">€1.00 / credito</p>
              </div>
              <button className="px-4 py-2 text-sm font-medium text-navy bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors" data-id="element-426">
                €49
              </button>
            </div>
          </div>

          {/* Package 2 - Popular */}
          <div className="bg-white border-2 border-teal-deep rounded-xl p-4" data-id="element-427">
            <div className="flex items-center justify-between" data-id="element-428">
              <div data-id="element-429">
                <div className="flex items-center gap-2" data-id="element-430">
                  <p className="text-sm font-semibold text-navy" data-id="element-431">100 crediti</p>
                  <span className="text-[10px] font-bold text-teal-700 bg-teal-50 px-1.5 py-0.5 rounded" data-id="element-432">
                    -10%
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-433">€0.89 / credito</p>
              </div>
              <button className="px-4 py-2 text-sm font-medium text-white bg-teal-deep rounded-lg hover:bg-teal-800 transition-colors" data-id="element-434">
                €89
              </button>
            </div>
          </div>

          {/* Package 3 */}
          <div className="bg-white border border-gray-200 rounded-xl p-4 hover:border-gray-300 transition-colors" data-id="element-435">
            <div className="flex items-center justify-between" data-id="element-436">
              <div data-id="element-437">
                <div className="flex items-center gap-2" data-id="element-438">
                  <p className="text-sm font-semibold text-navy" data-id="element-439">150 crediti</p>
                  <span className="text-[10px] font-bold text-green-700 bg-green-50 px-1.5 py-0.5 rounded" data-id="element-440">
                    -20%
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-441">€0.79 / credito</p>
              </div>
              <button className="px-4 py-2 text-sm font-medium text-navy bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors" data-id="element-442">
                €119
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Transaction History Section */}
      <div className="mb-6" data-id="element-443">
        <div className="flex items-center gap-2 mb-3" data-id="element-444">
          <History size={14} className="text-gray-400" data-id="element-445" />
          <h2 className="text-xs text-gray-400 uppercase tracking-wider font-medium" data-id="element-446">
            Storico transazioni
          </h2>
        </div>

        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-447">
          <div className="divide-y divide-gray-100" data-id="element-448">
            {transactions.map(tx => <div key={tx.id} className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors" data-id="element-449">
                <div className="flex items-center gap-3" data-id="element-450">
                  <span className="text-xs text-gray-400 w-12" data-id="element-451">{tx.date}</span>
                  <span className="text-sm text-navy" data-id="element-452">{tx.description}</span>
                </div>
                <span className={`text-sm font-semibold ${tx.amount > 0 ? 'text-green-600' : 'text-gray-500'}`} data-id="element-453">
                  {tx.amount > 0 ? '+' : ''}
                  {tx.amount}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {/* Info Footer */}
      <p className="text-xs text-gray-400 text-center" data-id="element-454">
        I crediti non hanno scadenza e non sono rimborsabili.
      </p>
    </MobileLayout>;
}